module.exports = __webpack_public_path__ + "media/images/default/shared/header/logo-7ee3234d833e45344377701741745c88.svg";